import { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import { Icon } from '@mercator-gcp/grout';
import SectionItem from 'components/widgets/Dashboard/FlyoutMenu/SectionItem';
import SectionItemList from 'components/widgets/Dashboard/FlyoutMenu/SectionItemList';

type TSectionDropdownProps = {
  label: string;
  numProjects?: number;
  isActive?: boolean;
  isExpanded: boolean;
  onClick: () => void;
  children: ReactNode;
};

const SectionDropdown = ({
  label,
  numProjects,
  isActive,
  onClick,
  isExpanded,
  children,
}: TSectionDropdownProps) => {
  return (
    <Box>
      <SectionItem
        sx={{ paddingY: 'padding_8' }}
        label={label}
        numProjects={numProjects}
        iconName={isExpanded ? Icon.Name.ChevronDownFilled : Icon.Name.ChevronRightFilled}
        isActive={isActive}
        onClick={onClick}
      />
      {isExpanded && <SectionItemList isSubsection>{children}</SectionItemList>}
    </Box>
  );
};

export default SectionDropdown;
